import type { PwaView, SubjectPack } from "../ai_literacy/subjectPack.js";
import { buildFirstAidGraph, FIRST_AID_NODE_IDS } from "./curriculum.js";
import {
  COPY,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  getCopy,
  type Locale,
  type LocaleStrings,
  type StemTemplate,
} from "./conceptCopy.js";
import { FIRST_AID_SEED_QUESTIONS } from "./seed.js";
import { FIRST_AID_BACKPACK_DECK } from "./decks/backpack.js";
import { FIRST_AID_SPOTLIE_DECK } from "./decks/spotlie.js";
import { FIRST_AID_REDACT_DECK } from "./decks/redact.js";

function recommendViewFirstAid(conceptId: string | null): PwaView | null {
  if (!conceptId) return null;
  if (conceptId === "bleeding_basic") return "backpack";
  if (conceptId === "scene_safety" || conceptId === "emergency_call") return "spotlie";
  if (conceptId === "recovery_position") return "redact";
  return "mcq";
}

/** Short proof pack: ~10 seed MCQs + mini-game decks (M.4). Not a certified course. */
export const FIRST_AID_PACK: SubjectPack = {
  id: "first_aid",
  buildGraph: buildFirstAidGraph,
  conceptIds: FIRST_AID_NODE_IDS,
  copy: COPY,
  getCopy,
  defaultLocale: DEFAULT_LOCALE,
  supportedLocales: SUPPORTED_LOCALES,
  seedQuestions: FIRST_AID_SEED_QUESTIONS,
  recommendViewForConcept: recommendViewFirstAid,
  quest: {
    id: "basics",
    steps: [
      { conceptId: "scene_safety", minElo: 1250 },
      { conceptId: "emergency_call", minElo: 1250 },
      { conceptId: "bleeding_basic", minElo: 1280 },
      { conceptId: "recovery_position", minElo: 1280 },
    ],
  },
  decks: {
    backpack: FIRST_AID_BACKPACK_DECK,
    spotlie: FIRST_AID_SPOTLIE_DECK,
    redact: FIRST_AID_REDACT_DECK,
  },
};

export type { Locale, LocaleStrings, StemTemplate };
